import type { Tone } from "@/components/ui/StatusBadge";

/** The backend refreshes tokens this long before expiry (EZYVET_REFRESH_MARGIN_MINUTES). */
export const REFRESH_MARGIN_S = 30 * 60;
export const MAX_BACKFILL_DAYS = 365;

export function tokenHealth(connected: boolean, expiresAt: number | null, now: number): { tone: Tone; label: string } {
  if (!connected) return { tone: "neutral", label: "Not connected" };
  if (!expiresAt) return { tone: "unbilled", label: "No token" };
  const ttl = (expiresAt - now) / 1000;
  if (ttl <= 0) return { tone: "unbilled", label: "Token expired" };
  if (ttl <= REFRESH_MARGIN_S) return { tone: "discrepancy", label: "Refreshing soon" };
  return { tone: "synced", label: "Token valid" };
}

export function quotaTone(remaining: number, limit: number): Tone {
  const share = limit > 0 ? remaining / limit : 0;
  if (share <= 0.15) return "unbilled";
  if (share <= 0.5) return "discrepancy";
  return "synced";
}

/** Local calendar day as YYYY-MM-DD (what <input type="date"> uses). */
export function isoDay(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function validateBackfill(from: string, to: string, today: string): string | null {
  if (!from || !to) return "Choose both dates.";
  if (from > to) return "The start date must be on or before the end date.";
  if (to > today) return "The end date can't be in the future.";
  const days = (Date.parse(to) - Date.parse(from)) / 86_400_000 + 1;
  if (days > MAX_BACKFILL_DAYS) return `Backfill at most ${MAX_BACKFILL_DAYS} days at a time.`;
  return null;
}
